import { render, staticRenderFns } from "./VodRequest.vue?vue&type=template&id=1ae3c844&scoped=true"
import script from "./VodRequest.vue?vue&type=script&lang=js"
export * from "./VodRequest.vue?vue&type=script&lang=js"
import style0 from "./VodRequest.vue?vue&type=style&index=0&id=1ae3c844&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae3c844",
  null
  
)

export default component.exports